import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageTestPage from "../molecules/PageTestPage";
import { readStoredStatus } from "../molecules/Page";
import SessionStatsPanel from "../molecules/SessionStatsPanel";

// Trasa /session-stats — fallback dla bezpośredniego wejścia po URL.
// W trakcie sesji statystyki pokazujemy jako overlay w SolveProblem (bez nawigacji),
// żeby nie odmontowywać ekranu zadania i nie przeskakiwać na kolejne zadanie.
const SessionStats = () => {
    const navigate = useNavigate();
    const [accountStatus] = useState(readStoredStatus);

    const sessionStartTime = Number(localStorage.getItem("sessionStartTime")) || 0;

    useEffect(() => {
        if (sessionStartTime === 0) {
            navigate('/app', { replace: true });
        }
    }, [sessionStartTime, navigate]);

    if (sessionStartTime === 0) return null;

    // userStatus.problems_solved_today jest aktualizowane po KAŻDEJ próbie (useProblemSolver)
    // i już zawiera zadania z tej sesji — używamy go bezpośrednio (spójne z SolveProblem).
    const dailyGoalProgress = accountStatus && accountStatus.problems_daily_goal > 0
        ? Math.min(100, (accountStatus.problems_solved_today / accountStatus.problems_daily_goal) * 100 + 5)
        : 0;

    return (
        <PageTestPage showNav accountStatus={accountStatus} dailyGoalProgress={dailyGoalProgress}>
            <SessionStatsPanel />
        </PageTestPage>
    );
};

export default SessionStats;
